import { createContext } from 'react';

const ViewContext = createContext({});

export default ViewContext;